export default __webpack_public_path__ + "static/media/promos-active.2c964781.webp";